import { render, staticRenderFns } from "./PayPlansListPage.vue?vue&type=template&id=c57fe320&scoped=true"
import script from "./PayPlansListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlansListPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlansListPage.vue?vue&type=style&index=0&id=c57fe320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57fe320",
  null
  
)

export default component.exports